<template>
  <div>
    <b-row>
      <b-col>
        <p>The following sales orders are <strong>ready</strong> to be shipped</p>
        <filters-component :filters="soReadyFilters" :keyNdx="1" isSalesOrdersFilter @onSearch="getData"/>
        <sales-orders-list
          :salesOrdersParentList="soReadyList"
          :gridId="gridId"
          isParentList
          hideEdit
          @selectedSalesOrder="onSOSelect"
          @onSort="onSort"
          class="mt-1" />

        <div class="flex-column mt-4">
          <div class="d-flex justify-content-between align-items-center">
            <p>Select a sales order line schedule to add to an invoice</p>
            <div>
              <b-button size="sm" variant="primary" :disabled="selectedSOScheduleId == 0 || isGettingPickList" @click="onShowPickList" class="mr-2">
                <i v-show="isGettingPickList" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
                {{ isGettingPickList ? 'Getting' : '' }} Pick List
              </b-button>
              <b-button size="sm" variant="primary" :disabled="isDisabledAddToInvoice" @click="onAddToInvoice">Add to Invoice</b-button>
            </div>
          </div>
        </div>
          <sales-order-line-schedules-list
            :salesOrderSchedulesFiltered="soScheduleReadyList"
            :gridId="gridScheduleId"
            isFilteredList
            @selectedSOSchedule="onSOLineScheduleSelect"
            class="mt-1"
          />
      </b-col>
    </b-row>
    <pick-list-modal
      :sOScheduledObj="soScheduleSelected"
      :pickTicketList="pickTicketLines"
      :pickTicketListName="pickTicketListName"
      :modalId="modalId"
      @addToInvoice="onAddToInvoice"
      @refreshData="getPickTicketLineData"  />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

import FiltersComponent from '../../../FilterComponent';

import moment from 'moment';
import { DATE_FORMAT, GRID_ID } from '@/shared/constants';
import SalesOrdersList from '@/shared/components/SalesOrders';
import SalesOrderLinesList from '@/pages/SalesOrders/components/SalesOrderLines'
import SalesOrderLineSchedulesList from '@/shared/components/SalesOrderLineSchedules';
import PickListModal from '@/shared/components/PickList';
import { filter } from 'minimatch';
import debounce from 'lodash/debounce';

const PROCESS_DEBOUNCE_TIME = 750;

export default {
  components: {
    FiltersComponent,
    SalesOrdersList,
    SalesOrderLinesList,
    SalesOrderLineSchedulesList,
    PickListModal
  },
  data() {
    return {
      DATE_FORMAT,
      soReadyFilters: {
        asOfDate: moment().format(DATE_FORMAT)
      },
      selectedRowItemId: 0,
      selectedSOScheduleId: 0,
      soScheduleSelected: {},
      scheduleListName: 'soScheduleReadyList',
      pickTicketListName: 'pickTicketLinesForReady',
      modalId: 'pick-list-ready-modal',
      gridId: GRID_ID.SALES_ORDERS_SHIPPING_READY,
      gridScheduleId: GRID_ID.SALES_ORDERS_SCHEDULES_SHIPPING_READY,
      isGettingPickList: false
    };
  },
  computed: {
    ...mapGetters('shippingReceiving', [
      'soReadyList',
      'soLineReadyList',
      'soScheduleReadyList',
      'soPageInfo'
    ]),
    ...mapGetters('pickTicket', ['pickTicketLinesForReady']),
    isDisabledAddToInvoice() {
      // return (this.pickTicketLinesForReady.length > 0)
      // ? this.pickTicketLinesForReady.filter(x => x.isConfirmed == true).length == 0 : true;
      return this.selectedSOScheduleId == 0;
    },
    isPickTicketConfirmed() {
      return this.pickTicketLines.filter(x => x.isConfirmed == true).length > 0;
    },
    pickTicketLines() {
      return this.pickTicketLinesForReady.lines;
    }
  },
  methods: {
    ...mapActions('shippingReceiving', [
      'getSoLinesSchedules',
      'getSoLinesBySelectedSo',
      'getSoScheduleBySelectedSo',
      'setSortInfo'
    ]),
    ...mapActions('pickTicket', ['getPickTicketLinesForKey']),
    ...mapMutations('shippingReceiving', ['setItem']),
    /*...mapMutations('pickTicket', ['setPickTicketLinesForKey']),*/
    ...mapMutations('pickTicket', {pickTicketSetItem:'setItem'}),
    async getData() {
      /*this.setList({ key: this.scheduleListName, value: [] });*/
    
      await this.getSoLinesSchedules({
        filters: {
          ...this.soReadyFilters,
          isReady: true,
          isPastDue: false,
          isNotScheduled: false,
        }
      })
    },
    async onSOSelect($event) {
      this.selectedSOScheduleId = 0;
      this.soScheduleSelected = {};
      this.selectedSOItemId = $event.id;
      /*this.setPickTicketLinesForKey({key: this.pickTicketListName, value: []});*/
      this.pickTicketSetItem({ resource: this.pickTicketListName, payload: [] });
      await this.getSoScheduleBySelectedSo({salesOrderId: $event.id, isState: this.scheduleListName});
    },
    async onSOLineScheduleSelect($event) {
      this.selectedSOScheduleId = $event.id;
      this.$emit('onSelectedSchedule', $event.id);
      this.soScheduleSelected = this.soScheduleReadyList.find(x => x.id == $event.id);
      this.isGettingPickList = true;
      await this.getPickTicketLineData().catch(() => this.isGettingPickList = false);
      this.isGettingPickList = false;
    },
    async getPickTicketLineData() {
      await this.getPickTicketLinesForKey({salesOrderLineScheduleId: this.selectedSOScheduleId, state: this.pickTicketListName});
    },
    onAddToInvoice() {
      if (this.isPickTicketConfirmed) {
        this.$emit('addToInvoice', this.soScheduleSelected);
      } else {
        this.onShowPickList();
      }
    },
    onShowPickList() {
      this.$bvModal.show(this.modalId);
    },
    onSort(evt) {
      this.setSortInfo({ ...evt, pageInfoState: 'soPageInfo' });
    }
  },
  watch: {
    soPageInfo() {
      this.getData()
    }
  },
  mounted() {
    this.setItem({ resource: this.scheduleListName, payload: [] });
    this.getData();
  }
};
</script>

<style scoped>
.sched-division {
    padding: 0.5rem;
    margin-top: 2rem;
}
</style>